import { Action } from '../../actions';
import {
  firstReferenceFromReferenceList,
  mergeEntities,
  transformObjects,
} from '../../helpers';
import {
  transformPendingFunds,
  transformUserBalance,
} from '../../user/user.transformers';

export function navigationUserBalancesReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationUserBalances') {
        const { result, refList } = action.payload;
        return mergeEntities<'navigationUserBalances'>(
          state,
          transformObjects(
            result.account_balances && result.account_balances.balances,
            transformUserBalance,
            result,
          ),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}

export function navigationPendingFundsReducer(state = {}, action: Action) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'navigationPendingFunds') {
        const { result, refList } = action.payload;
        return mergeEntities<'navigationPendingFunds'>(
          state,
          transformObjects(
            result.account_balances && result.account_balances.pending_funds,
            transformPendingFunds,
            result,
          ),
          firstReferenceFromReferenceList(refList),
        );
      }
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/app/@shared/datastore/navigation/user-balances/user-balances.reducer.ts